import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DiningSummary from '../diningSummary/DiningSummary';
import { virtualPageView } from '../../googleTagManager';
import './Summary.scss';

const Summary = ({ diningLabel, dinings, shouldFetchAvailableAddons, getAvailableAddons, resId }) => {
  useEffect(() => {
    if (shouldFetchAvailableAddons) getAvailableAddons(resId);
  }, [shouldFetchAvailableAddons, getAvailableAddons, resId]);

  useEffect(() => {
    virtualPageView('plan my day', 'book more', '/ga-virtual/plan-my-day/book-more');
  }, []);

  return (
    <div className="summary">
      { !!dinings && dinings.length > 0 && <DiningSummary label={diningLabel} dinings={dinings} /> }
    </div>
  );
};

Summary.propTypes = {
  diningLabel: PropTypes.string.isRequired,
  dinings: PropTypes.array.isRequired,
  resId: PropTypes.number.isRequired,
  getAvailableAddons: PropTypes.func.isRequired,
  shouldFetchAvailableAddons: PropTypes.bool.isRequired,
};

export default Summary;
